import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'CallForActionForm'

export const RESET_CALL_FOR_ACTION = `${typeKey}/RESET_CAL_FOR_ACTION`
export const CHANGE_CALL_FOR_ACTION_PROPERTY = `${typeKey}/CHANGE_CALL_FOR_ACTION_PROPERTY`

export const GET_CALL_FOR_ACTION_ASYNC = createAsyncTypes('GET_CALL_FOR_ACTION', typeKey)
export const ADD_CALL_FOR_ACTION_ASYNC = createAsyncTypes('ADD_CALL_FOR_ACTION', typeKey)
export const EDIT_CALL_FOR_ACTION_ASYNC = createAsyncTypes('EDIT_CALL_FOR_ACTION', typeKey)
